module.exports = __webpack_public_path__ + "static/media/DSC00632-3_Small.05e589c1.jpg";